/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Node } from '../../../core/models/Node';
import { IVisitor } from '../../../core/visitors/IVisitor';
import { IOas30Visitor } from '../visitors/IOas30Visitor';
import { IOas30Expression } from './IOas30Expression';

/**
 * Constructor.
 * @param {string} value
 * @class
 * @extends Node
 * @author eric.wittmann@gmail.com
 */
export class Oas30LinkRequestBodyExpression extends Node implements IOas30Expression {
    /*private*/ _value : string;

    public constructor(value : string) {
        super();
        if(this._value===undefined) this._value = null;
        this._value = value;
    }

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let viz : IOas30Visitor = <IOas30Visitor><any>visitor;
        viz.visitLinkRequestBodyExpression(this);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.models.IOas30Expression#getValue()
     * @return {string}
     */
    public getValue() : string {
        return this._value;
    }

    /**
     * Returns true if the expression is a dynamic link parameter expression that must be evaluated.
     * @return {boolean}
     */
    public isExpression() : boolean {
        return this.getValue() != null && this.getValue().indexOf("$") === 0;
    }

    /**
     * Returns true if the expression is just a constant value.
     * @return {boolean}
     */
    public isConstant() : boolean {
        return !this.isExpression();
    }
}
Oas30LinkRequestBodyExpression["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30LinkRequestBodyExpression";
Oas30LinkRequestBodyExpression["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.openapi.v3.models.IOas30Expression"];




